import { collection, getDocs, query, where } from 'firebase/firestore';
import Failure from '../../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../../firebase.config';
import UserDoc from '../../../models/UserDoc';

async function getVoipEnabledUsers(): Promise<UserDoc[]> {
  try {
    const db = firestore;
    const usersCollection = collection(db, FirestoreCollections.users);
    const results = await getDocs(
      query(usersCollection, where('voip_enabled', '==', true))
    );

    const users: UserDoc[] = [];
    results.docs.forEach((doc) => {
      users.push(UserDoc.fromFirestore(doc));
    });

    return users.sort((a, b) => b.created - a.created);
  } catch (e) {
    console.log('error: ', e);
    throw new GetVoipEnabledUsersFailure();
  }
}

export class GetVoipEnabledUsersFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getVoipEnabledUsers;
